import RevenueCenter from './RevenueCenter'
import RevenueCenterChild from './RevenueCenterChild'

export { RevenueCenterChild }
export default RevenueCenter
